module.exports = __webpack_public_path__ + "static/slide2-9f702ac9584de146bb9358d0fb1fde02.jpg";